export default "__VITE_ASSET__ce414903__"